import React from 'react';
import { Menu } from 'lucide-react';
import { clientNavItems } from '../../../config/clientNav';

interface MobileHeaderProps {
  currentView: string;
  onMenuClick: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ currentView, onMenuClick }) => {
  const title = clientNavItems.find((item) => item.view === currentView)?.label ?? 'Mission Control';

  return (
    <header className="mc-mobile-header">
      <button className="mc-mobile-menu-btn" onClick={onMenuClick} aria-label="Open menu">
        <Menu size={24} />
      </button>
      <h1 className="mc-mobile-title">{title}</h1>
    </header>
  );
};
